document.documentElement.classList.remove('no-js');

const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency: window.Shopify?.currency?.active || 'MXN' }).format(cents / 100);
const overlay = document.querySelector('[data-cart-overlay]');
const openCart = () => { if (overlay) overlay.hidden = false; };
const closeCart = () => { if (overlay) overlay.hidden = true; };

document.querySelector('[data-menu-toggle]')?.addEventListener('click', () => document.querySelector('[data-menu]')?.classList.toggle('open'));
document.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
document.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));
overlay?.addEventListener('click', event => { if (event.target === overlay) closeCart(); });

async function refreshCart() {
  const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json());
  document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
  document.querySelectorAll('[data-cart-total]').forEach(node => node.textContent = money(cart.total_price));
  const lines = document.querySelector('[data-cart-lines]');
  if (lines) lines.innerHTML = cart.items.length ? cart.items.map(item => `<article>${item.image ? `<img src="${item.image}" alt="">` : ''}<div><b>${item.product_title}</b><small>${item.variant_title || ''} · Cantidad: ${item.quantity}</small><strong>${money(item.final_line_price)}</strong></div></article>`).join('') : '<p>Tu carrito está vacío.</p>';
}

document.querySelectorAll('[data-product-form]').forEach(form => form.addEventListener('submit', async event => {
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const original = button.textContent;
  button.disabled = true; button.textContent = 'AGREGANDO…';
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('No se pudo agregar el producto');
    await refreshCart(); openCart();
  } catch (error) { alert(error.message); }
  finally { button.disabled = false; button.textContent = original; }
}));
